import { render, staticRenderFns } from "./Creation_4_Skills.vue?vue&type=template&id=6dfb3d75&scoped=true&"
import script from "./Creation_4_Skills.vue?vue&type=script&lang=js&"
export * from "./Creation_4_Skills.vue?vue&type=script&lang=js&"
import style0 from "./Creation_4_Skills.vue?vue&type=style&index=0&id=6dfb3d75&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfb3d75",
  null
  
)

export default component.exports